import * as yup from "yup";

import { VALIDATION_REGEXES } from "@dl/declarations";

export interface SetPasswordFormData {
  currentPassword?: string;
  newPassword: string;
  confirmPassword: string;
}

export const getSetPasswordSchema = (needsCurrentPassword: boolean) => {
  return yup.object({
    currentPassword: needsCurrentPassword
      ? yup
          .string()
          .required("Current password is required")
          .label("Current password")
      : yup.string().optional().label("Current password"),
    newPassword: yup
      .string()
      .required("Password is required")
      .matches(VALIDATION_REGEXES.PASSWORD, "Password not strong enough")
      .label("New password"),
    confirmPassword: yup
      .string()
      .required("Please confirm your password")
      .oneOf([yup.ref("newPassword")], "Passwords must match")
      .label("Confirm password"),
  });
};

export interface SignInFormData {
  email: string;
  password: string;
}

export const signInSchema = yup.object({
  email: yup
    .string()
    .email("Invalid email address")
    .required("Email is required")
    .label("Email"),
  password: yup.string().required("Password is required").label("Password"),
});

export interface TwoFactorFormData {
  code: string;
}

export const twoFactorSchema = yup.object({
  code: yup
    .string()
    .required("Verification code is required")
    .length(6, "Code must be 6 digits")
    .matches(/^\d+$/, "Code must contain only numbers")
    .label("Verification code"),
});
